module.exports = __webpack_public_path__ + "ad41da3b6cc460f23aa11e5805a43cf6.jpg";